import useDayjs from './useDayjs';
import useIsMobile from './useIsMobile';

export const OFFERING_CLOSED = 'CLOSED';

const useOfferingDaysLeft = () => {
  const dayjs = useDayjs();
  const isMobile = useIsMobile();

  const getTillOfferingClose = (tombstone) => {
    const isRegD = tombstone?.regulationType === 'Reg D' || tombstone?.regulationType === '506c';
    const isTTW = tombstone?.status === 'testing';
    const isClosed = tombstone?.status === 'closed';

    if (isClosed) {
      return OFFERING_CLOSED;
    }

    if (!isClosed) {
      if (isTTW && isMobile) {
        return null;
      }

      if (isTTW && !isMobile) {
        return 'RESERVE NOW';
      }

      if (isRegD) {
        return '';
      }

      if (typeof window === 'undefined') {
        return null;
      }

      if (typeof window !== 'undefined') {
        if (!tombstone?.endDate) {
          return '';
        }

        const tillOfferingClose = dayjs.utc(dayjs(tombstone.endDate)).diff(dayjs(), 'hours');

        if (
          !Number.isFinite(tillOfferingClose) ||
          tillOfferingClose < 0 ||
          tillOfferingClose >= 744
        ) {
          return '';
        }

        if (tillOfferingClose > 24) {
          if (tillOfferingClose < 48) {
            return '1 DAY LEFT';
          }

          return `${Math.floor(tillOfferingClose / 24)} DAYS LEFT`;
        }

        if (tillOfferingClose < 1) {
          const minutesLeft = dayjs.utc(dayjs(tombstone.endDate)).diff(dayjs(), 'minutes');

          if (!Number.isFinite(minutesLeft) || minutesLeft <= 0) {
            return '';
          }

          return `${minutesLeft} MINUTE${minutesLeft === 1 ? '' : 'S'} LEFT`;
        }

        return `${tillOfferingClose} HOUR${tillOfferingClose === 1 ? '' : 'S'} LEFT`;
      }
    }

    return null;
  };

  return [getTillOfferingClose];
};

export default useOfferingDaysLeft;
